import React from "react";
import ReactDOM from "react-dom/client";
import App from "./AppNew";
import "./styles.css";
import "./settings.css";
import "./scripts.css";
import "./assistant.css";
import "./new-ui.css";

ReactDOM.createRoot(document.getElementById("root")!).render(<React.StrictMode><App /></React.StrictMode>);
